import * as tough from 'tough-cookie';

import { logAuthSession } from '../logger';
import { isServer } from '../utils';

/**
 * @param {object} ctx - The Koa server context Object.
 * @returns {object}
 */
export const cookiePublicDomain = (ctx) =>
  ctx.hostname.split('.').slice(-2).join('.');

/**
 * Switches cookie domain for auth service from internal to public
 * (so that we could inject the cookies into the client session)
 *
 * @exports
 * @param {object} ctx - The Koa server context Object.
 *  @param {Array} setCookieHeaders -
 * @returns {Array}
 */
export const switchAuthCookieToPublicDomain = (ctx, setCookieHeaders) => {
  // Only change domain on the server side, which uses the internal auth url
  if (!isServer) return setCookieHeaders;

  try {
    const domain = cookiePublicDomain(ctx);
    logAuthSession(`switching cookies to public domain ${domain}`);
    return setCookieHeaders.map((oldCookie) => {
      // parse a Set-Cookie response header
      const cookie = tough.Cookie.parse(oldCookie);
      // inject auth service public domain
      cookie.domain = domain;
      // generate a Set-Cookie response header
      const newCookie = cookie.toString();
      logAuthSession(`using public domain on ${newCookie}`);
      return newCookie;
    });
  } catch (error) {
    ctx.log.error(error);
    // fallback to the original headers
    return setCookieHeaders;
  }
};
